"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.localeTemplateSchema = exports.localeTemplateEntrySchema = void 0;
var _zod = require("zod");
const localeTemplateEntrySchema = exports.localeTemplateEntrySchema = _zod.z.strictObject({
  notes: _zod.z.string().optional().describe('Additional information for translators'),
  context: _zod.z.string().optional().describe('Context for translators, e.g. male/female; see https://lokalise.com/blog/the-3-pillars-of-context-that-will-improve-your-translations'),
  limit: _zod.z.number().optional().describe('Character limit'),
  tags: _zod.z.array(_zod.z.string()).optional().describe('See https://docs.lokalise.com/en/articles/1475552-tags'),
  translation: _zod.z.union([_zod.z.string().describe('Singular translation'), _zod.z.strictObject({
    one: _zod.z.string().describe('Singular form'),
    other: _zod.z.string().describe('Plural form')
  }).describe('Plural translation')])
});
const localeTemplateSchema = exports.localeTemplateSchema = _zod.z.strictObject({
  $schema: _zod.z.string().optional().describe('This should be a path/URL pointing to our schema (e.g. `node_modules/@bamboohr/utils/lib/locale-template-schema.json`), enabling validation in editors that support JSON Schema.'),
  translations: _zod.z.record(_zod.z.string(), localeTemplateEntrySchema).describe('Dictionary of translations')
});

/**
 * A dictionary of translations with additional metadata.
 * See https://docs.lokalise.com/en/articles/3229161-structured-json
 */